/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTeamPlannerRequest } from '../../models/create-team-planner-request';
import { TeamPlannerDto } from '../../models/team-planner-dto';

export interface CreateTeamPlanner$Params {
      body: CreateTeamPlannerRequest
}

export function createTeamPlanner(http: HttpClient, rootUrl: string, params: CreateTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
  const rb = new RequestBuilder(rootUrl, createTeamPlanner.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerDto>;
    })
  );
}

createTeamPlanner.PATH = '/v0/teamPlanners/{id}';
